const { LOCAL_ENVIRONMENT, DEV_ENVIRONMENT, QA_ENVIRONMENT, STAGING_ENVIRONMENT, OCULTO_ENVIRONMENT, PRODUCTION_ENVIRONMENT } = require('constants/index');

const databankEnvironments = {
    LOCAL: "LOCAL",
    DEV: "DEV",
    QA: "QA",
    STG: "STG",
    OCU: "OCU",
    PROD: "PROD"
};

const getEnvironment = environment =>  {
    switch (environment) {
        case LOCAL_ENVIRONMENT:
            return databankEnvironments.LOCAL;
        case DEV_ENVIRONMENT:
            return databankEnvironments.DEV;
        case QA_ENVIRONMENT:
            return databankEnvironments.QA;
        case STAGING_ENVIRONMENT:
            return databankEnvironments.STG;
        case OCULTO_ENVIRONMENT:
            return databankEnvironments.OCU;
        case PRODUCTION_ENVIRONMENT:
            return databankEnvironments.PROD;
        default:
            throw new Error(`Unknown environment '${environment}'.`)
    }
};

const getDatabankTranslations = (translations, currentLocale) => {
    const allTranslations = translations.get('translations');
    if (!allTranslations) {
        return null;
    }

    const currentLocaleTranslations = allTranslations.toJS()[currentLocale];
    return currentLocaleTranslations ? currentLocaleTranslations.databank : null;
};

module.exports = {
  LOGIN: "LOGIN",
  EXIT_APP: "EXIT_APP",
  TEALIUM_EVENT: "TEALIUM_EVENT",
  TEALIUM_EVENT_TYPE_RECORD_PATH: "RECORD_PATH",
  TEALIUM_EVENT_TYPE_RECORD_LINK: "RECORD_LINK",
  getEnvironment,
  getDatabankTranslations
};
